import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router";

import NotificationAlert from "react-notification-alert";
import notificationManager from "managers/notificationManager";

import { staticData } from "managers/staticDataManager";
import { Card, Container, Row, Col } from "reactstrap";
import ReactNotificationAlert from "react-notification-alert";
import BackToLogin from "components/BackToLogin";

import { handleConfirmEmail } from "../callApi";

const ConfirmEmail = () => {
  document.documentElement.classList.remove("nav-open");
  React.useEffect(() => {
    document.body.classList.add("register-page");
    return function cleanup() {
      document.body.classList.remove("register-page");
    };
  });

  const { token } = useParams();
  const notificationAlertRef = React.useRef(null);
  const state = useSelector((state) => state);
  const [isSuccess, setIsSuccess] = useState(false);

  React.useEffect(() => {
    confirmEmail(token);
  }, [token]);

  const confirmEmail = (data) => {
    handleConfirmEmail(state, data, setIsSuccess, notificationAlertRef);
  }

  return (
    <React.Fragment>
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" lg="6">
            <Card className="card-register ml-auto mr-auto">
              <div hidden={isSuccess}>
                  <div className="form-check-label" ><b>{staticData.loadTerms(state, "VW_ISSUER_ConfirmEmail_BusyMessage")}</b></div>
              </div>
              <div hidden={!isSuccess}>
                <div className="card-body">
                    <div ><b>
                      <div className="form-check-label" ><b>{staticData.loadTerms(state, "VW_ISSUER_ConfirmEmail_DoneMessage")}</b></div>
                    </b></div>
                </div>
                <BackToLogin />
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <div className="react-notification-alert-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
    </React.Fragment>
  );
}

export default ConfirmEmail;
